import { hot } from 'react-hot-loader/root'
import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { withScriptjs } from 'commons/js/components/Map'
import { EPProvider, PromoBannerProvider } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'
import { messages } from 'commons/js/messages'
import Routes from 'commons/js/routes/routes'
import { defaultLocale, currentLocale } from 'commons/js/locale'
import { parkingsParams } from './defaultParams'
import theme from 'parking-search-map/js/theme'

import { geocodePlace } from 'commons/js/services/geocoderService'
import LocationDetector from './components/LocationDetector'
import ParkingContainer from './container/ParkingContainer'
import Parkings from './container/ParkingContainer/Parkings'

const ParkingContainerWrapper = (props) => {
    return (
        <ParkingContainer {...props}>
            {(containerProps) => <Parkings {...containerProps} />}
        </ParkingContainer>
    )
}

const ParkingContainerWithLocation = (routeProps) => {
    return (
        <LocationDetector
          {...routeProps}
          component={ParkingContainerWrapper}
          geocodePlace={geocodePlace}
          defaultParams={parkingsParams}
        />
        )
}

const App = ({showFilterBox}) => (
    <IntlProvider locale={currentLocale} defaultLocale={defaultLocale} messages={messages[currentLocale]}>
        <EPProvider theme={theme} {...convertConstantToEPProviderFormat()}>
            <PromoBannerProvider>
                <BrowserRouter>
                    <Switch>
                        <Route path={Routes.parkingsSearchPath()} render={(props) =>
                            <ParkingContainerWithLocation
                              {...props}
                              showFilterBox={showFilterBox}
                            />
                        } />
                    </Switch>
                </BrowserRouter>
            </PromoBannerProvider>
        </EPProvider>
    </IntlProvider>
)

const AppWithScript = withScriptjs(App)

App.propTypes = {
    showFilterBox: PropTypes.bool.isRequired,
}

export default hot(AppWithScript)
